export default __webpack_public_path__ + "static/media/dnsresolver.b993bf68.png";